<template>
<div>
  <Row :gutter="16">
    <Col span="12">
      <Select v-model="selectedPcbId" filterable
        clearable
          remote
          :loading="loading"
          :remote-method="handleSearchPcbAssociation" >
        <Option v-for="pcbOption in pcbAssociationMatches" :value="pcbOption.id" :key="pcbOption.id" :label="pcbOption.name">
          {{pcbOption.name}}
        </Option>
      </Select>
    </Col>
    <Col span="12">
        <Button :disabled="!selectedPcbId" type="primary" @click="handleAddPcbAssociation">{{ $t('associate') }}</Button>
    </Col>
  </Row>
  <br>
  <div class="clear">
    <Table :data="pcbs" :columns="columns">
        <template slot-scope="{ row, column, index }" slot="propsCell">
          {{_.get(row, column.key)}}
        </template>
        <template slot-scope="{ row, column, index }" slot="dimensionCell">
          <span v-if="row.specification">
            {{row.specification.width}} * {{row.specification.height}} {{row.specification.measurement_unit}}
          </span>
        </template>
        <template slot-scope="{ row, column, index }" slot="actionCell">
          <router-link :to="pcbViewRoute(row)" target="_blank">
            <Button type="text" size="small" icon="md-create"></Button>
          </router-link>
          <Poptip transfer
            confirm
            :title="$t('product.remove_association_confirmation')"
            @on-ok="handleRemovePcbAssociation(row)">
            <Button type="text" style="margin-left:5px;" size="small" icon="ios-trash"></Button>
          </Poptip>
        </template>
    </Table>
  </div>
</div>

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ProductPcbPlugin',
  props: {
    productId: {
      required: true
    }
  },
  data() {
    return {
      pcbs: [],
      loading: false,
      pcbAssociationMatches: [],
      selectedPcbId: null,
      columns: [
        {
          key: 'name',
          title: 'Board Name',
          align: 'left'
        },
        {
          key: 'action',
          title: 'Actions',
          align: 'right',
          slot: 'actionCell',
          maxWidth: 100
        }
      ]
    }
  },
  watch: {
    productId: function () {
      this.handleLoadAssociatedPcb()
    }
  },
  mounted () {
    this.handleLoadAssociatedPcb()
  },
  methods: {
    ...mapActions([
      'getProductAssociatedPcb',
      'searchProductAssociatedPcb',
      'addProductAssociatedPcb',
      'removeProductAssociatedPcb'
    ]),
    handleRemovePcbAssociation (pcb) {
      this.removeProductAssociatedPcb({ id: this.productId, pcb_id: pcb.id }).then((res) => {
        this.handleLoadAssociatedPcb()
      })
    },
    handleSearchPcbAssociation (keyword) {
      this.loading = true
      this.searchProductAssociatedPcb({ id: this.productId, keyword: keyword }).then(res => {
        this.pcbAssociationMatches = res.data
        this.loading = false
      })
    },
    canRemovePcbAssociation (pcb) {
      return _.toInteger(pcb.product_id) === _.toInteger(this.productId)
    },
    handleLoadAssociatedPcb() {
      this.getProductAssociatedPcb(this.productId).then((res) => {
        this.pcbs = res
      })
    },
    handleAddPcbAssociation () {
      this.loading = true
      this.addProductAssociatedPcb({ id: this.productId, pcb_id: this.selectedPcbId }).then(res => {
        this.handleLoadAssociatedPcb()
      })
    },
    pcbViewRoute (pcb) {
      return {
        name: 'menu.pcb.edit',
        params: {
          partId: pcb.id
        }
      }
    }

  }
}
</script>
